export const requiredName = 'Name is Required';
export const requiredPromoCode = 'Please enter Promo Code';
export const genericAddCardError = 'Error adding credit card';
